import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, Newspaper } from 'lucide-react';

const News = () => {
  const news = [
    {
      id: 1,
      title: 'Nouveaux bonus disponibles pour décembre 2025',
      excerpt: 'Découvrez les dernières offres promotionnelles des opérateurs agréés pour maximiser vos gains en cette fin d\'année.',
      date: '05.12.2025',
      link: '/news/nouveaux-bonus-decembre-2025',
      image: '/images/abhay-siby-mathew-HCi8OFNa_F8-unsplash.webp',
    },
    {
      id: 2,
      title: 'Guide complet : stratégies de paris sur le football',
      excerpt: 'Apprenez les techniques avancées pour analyser les matchs et améliorer votre taux de réussite sur les paris football.',
      date: '03.12.2025',
      link: '/news/strategies-paris-football',
      image: '/images/danny-lines-7yfKErZo5ro-unsplash.webp',
    },
    {
      id: 3,
      title: 'Comparatif des meilleures cotes du marché',
      excerpt: 'Notre analyse mensuelle révèle quels opérateurs proposent les cotes les plus avantageuses sur les principaux événements sportifs.',
      date: '01.12.2025',
      link: '/news/comparatif-cotes-decembre',
      image: '/images/akshay-gill-qk03WPpOS-Q-unsplash.webp',
    },
  ];

  return (
    <section id="news" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4 px-4 py-2 glass rounded-full border border-toxic-pink/30">
            <Newspaper className="w-5 h-5 text-toxic-pink" />
            <span className="text-sm text-toxic-pink font-semibold">Actualités</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-toxic-pink to-toxic-orange bg-clip-text text-transparent">
              Dernières actualités
            </span>
          </h2>
          <p className="text-xl text-white/70">
            Restez informé des dernières tendances et opportunités dans l'univers des paris sportifs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {news.map((item, index) => (
            <article
              key={item.id}
              className="glass-strong rounded-xl overflow-hidden border border-white/10 hover:border-toxic-pink/50 transition-all hover:scale-105 group"
              itemScope
              itemType="https://schema.org/NewsArticle"
            >
              <div className="relative h-48 bg-gradient-to-br from-purple-900/30 to-pink-900/30 overflow-hidden">
                <img
                  src={item.image}
                  alt=""
                  className="absolute inset-0 w-full h-full object-cover opacity-30"
                  loading="lazy"
                  decoding="async"
                  itemProp="image"
                />
                <div className="absolute top-4 left-4 px-3 py-1 glass rounded-full border border-toxic-pink/30">
                  <span className="text-xs text-toxic-pink font-semibold">Actualité</span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center gap-2 text-sm text-white/60 mb-3">
                  <Calendar className="w-4 h-4" />
                  <time itemProp="datePublished" dateTime="2025-12-05">{item.date}</time>
                </div>
                
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-toxic-pink transition-colors" itemProp="headline">
                  {item.title}
                </h3>
                
                <p className="text-white/70 text-sm leading-relaxed mb-4" itemProp="description">
                  {item.excerpt}
                </p>
                
                <Link
                  to={item.link}
                  data-discover="true"
                  className="inline-flex items-center gap-2 text-toxic-pink hover:text-toxic-orange font-semibold text-sm transition-colors group"
                  itemProp="url"
                >
                  Lire la suite
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;

